import request from "@/utils/request";
import { formDataHeaders } from "./api-header-conf.js";

export function login(data) {
  return request({
    headers: formDataHeaders,
    url: "/wxlogin",
    method: "post",
    data
  });
}

export function getOpenIdByCode(data) {
  return request({
    headers: formDataHeaders,
    url: "/wxcode",
    method: "post",
    data
  });
}
